import script from "./PresidentOffice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PresidentOffice.vue?vue&type=script&setup=true&lang=ts"

import "./PresidentOffice.vue?vue&type=style&index=0&id=15bafd7d&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15bafd7d"]])

export default __exports__